module.exports = __webpack_public_path__ + "img/lunch-check.79f1f8d0.svg";